import { boolean, object, string, type InferType } from "yup";

export const achConfirmValidation = object().shape({
  achConfirm: object().shape({
    fullName: string()
      .trim()
      .matches(/[^\s]+\s+[^\s+]/, "A full name must be provided for ACH signature")
      .required("Your electronic signature is required"),
    acceptance: boolean().oneOf([true], "Please accept the terms of the agreement"),
  }),
});

export type AchConfirmFormInputs = InferType<typeof achConfirmValidation>;
